export default __webpack_public_path__ + "static/media/vue.f1fd23be.svg";